import { FaPenAlt } from 'react-icons/fa'

const ViewRoles = ({
  data,
  editHandler,
}) => {
  return (
    <div className='table-responsive bg-light p-3 mt-2'>
      <div className='d-flex align-items-center flex-column mb-2'>
        <h3 className='fw-light text-muted'>
          Lista de roles
        </h3>

      </div>
      <table className='table table-sm table-border'>
        <thead className='border-0'>
          <tr>
            <th>Nombre</th>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          {data &&
            data.data.map((role) => (
              <tr key={role._id}>
                <td>{role.name}</td>
                <td>{role.type}</td>
                <td>{role.description}</td>

                <td className='text-center'>
                  <div className='btn-group'>
                    <button
                      className='btn btn-primary btn-sm rounded-pill'
                      onClick={() => editHandler(role)}
                      data-bs-toggle='modal'
                      data-bs-target='#roleModal'
                    >
                      <FaPenAlt />
                    </button>

                   
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default ViewRoles
